import { useIconButtonProvider } from '../IconButton/useIconButtonProvider';
import { useMemo } from 'react';
import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './const';
import { getIconSizeConst } from '../IconButton/utils';

export function useIconSizes({ height, width }: { height?: string | number; width?: string | number }) {
	const context = useIconButtonProvider();

	return useMemo(() => {
		const parsedHeight = typeof height === 'string' && height.trim().length > 0 ? parseInt(height, 10) : height;
		const parsedWidth = typeof width === 'string' && width.trim().length > 0 ? parseInt(width, 10) : width;
		let normalizedHeight = height;
		let normalizedWidth = width;

		if (!Number.isNaN(parsedHeight) && parsedHeight !== DEFAULT_HEIGHT) {
			normalizedHeight = parsedHeight;
		}

		if (!Number.isNaN(parsedWidth) && parsedWidth !== DEFAULT_WIDTH) {
			normalizedWidth = parsedWidth;
		}

		if (parsedHeight !== DEFAULT_HEIGHT || parsedHeight !== DEFAULT_WIDTH) {
			return {
				height: normalizedHeight,
				width: normalizedWidth,
			};
		}

		if (context === null) {
			return {
				height,
				width,
			};
		}

		const size = getIconSizeConst(context.size);

		return {
			height: size,
			width: size,
		};
	}, [context, height, width]);
}
